export default __webpack_public_path__ + "static/media/480_business04-es-web.764667ed.png";